import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

export const pensionNameAtom = atom<string | undefined>({
    default: "",
    key: ATOM_KEY.PENSION_NAME,
});

export const usePensionNameValue = () => useRecoilValue(pensionNameAtom);
export const useSetPensionNameState = () => useSetRecoilState(pensionNameAtom);
